import styled, { css, keyframes } from 'styled-components'

export type HistoryItemStatus = 'idle' | 'unread' | 'thinking'

export const HistoryItemContent = styled.div`
  display: flex;
  min-width: 0;
  flex: 1 1 auto;
  align-items: center;
  gap: 0.5rem;
  transition: opacity 150ms var(--ease-out-strong);

  [data-collapsible='icon'] & {
    opacity: 0;
  }
`

export const HistoryItemTitle = styled.div`
  min-width: 0;
  flex: 1 1 auto;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
`

export const HistoryItemMeta = styled.span`
  display: inline-flex;
  flex-shrink: 0;
  align-items: center;
  gap: 0.25rem;
  color: var(--muted-foreground);
`

const thinkingPulse = keyframes`
  50% { background: var(--sidebar-foreground); }
`

export const HistoryItemStatusDot = styled.span<{
  $status: HistoryItemStatus
}>`
  flex-shrink: 0;
  width: 0.375rem;
  height: 0.375rem;
  margin-inline: 0.3125rem;
  border-radius: 9999px;
  background: color-mix(in oklab, var(--muted-foreground) 50%, transparent);

  ${({ $status }) =>
    $status === 'unread' &&
    css`
      background: var(--color-blue-500);
    `}

  ${({ $status }) =>
    $status === 'thinking' &&
    css`
      animation: ${thinkingPulse} 1.2s ease-in-out infinite;

      @media (prefers-reduced-motion: reduce) {
        animation: none;
        background: var(--sidebar-foreground);
      }
    `}
`
